<template>
  <router-link :to="linkProfile" :class="colorEnlace">
    <v-progress-circular
      indeterminate
      color="blue"
      size="14"
      class="mb-0"
      v-if="loading"
    ></v-progress-circular>
    {{ nameProfile }}
  </router-link>
</template>

<script>
import firebase from "firebase";

let firebaseApp;
if (!firebase.apps.length) {
  firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyBnuZJIuRvweJ_qX4ZEmQCe2cerF92RCz4",
    authDomain: "tfgr-9ed26.firebaseapp.com",
    databaseURL: "https://tfgr-9ed26.firebaseio.com",
    projectId: "tfgr-9ed26",
    storageBucket: "tfgr-9ed26.appspot.com",
    messagingSenderId: "47742064305"
  });
} else {
  firebaseApp = firebase.app();
}

// Export the database for components to use.
// If you want to get fancy, use mixins or provide / inject to avoid redundant imports.
export const db = firebaseApp.database();

//Enlace con nombre a un objeto
// @group Interfaz extra
export default {
  name: "ProfileLink",
  props: {
    //ID del objeto
    idKey: {
      default: "",
      type: String
    },
    //Tipo de objeto
    type: {
      default: "",
      type: String
    }
  },
  data() {
    return {
      loading: true
    };
  },
  created() {
    this.$bindAsArray(
      "vectorObjecto",
      db
        .ref(this.tabla)
        .orderByChild(this.columna)
        .equalTo(this.idKey)
        .limitToFirst(1),
      snap => {
        this.loading = false;
      },
      error => {
        this.loading = false;
      }
    );
  },
  computed: {
    // @vuese
    // Tabla a la que acceder
    tabla() {
      if (this.type === "user") {
        return "users";
      }
      if (this.type === "sensor") {
        return "sensors";
      }
      if (this.type === "building") {
        return "buildings";
      }
      if (this.type === "group") {
        return "groups";
      }
      return "";
    },
    // @vuese
    // Columna por la que buscar
    columna() {
      if (this.type === "user") {
        return "uid";
      } else {
        return "key";
      }
    },
    // @vuese
    // Genera el enlace al objeto
    linkProfile() {
      if (this.type === "user") {
        return "/profile?id=" + this.idKey;
      }
      if (this.type === "sensor") {
        return "/dashboard/sensors/sensor?id=" + this.idKey;
      }
      if (this.type === "building") {
        return "/dashboard/buildings/building?id=" + this.idKey;
      }
      if (this.type === "group") {
        return "/dashboard/groups/group?id=" + this.idKey;
      }
      return "id=" + this.idKey;
    },
    // @vuese
    // Devuelve el nombre del objeto
    nameProfile() {
      if (this.loading) {
        return "Cargando";
      }
      if (this.vectorObjecto === null || this.vectorObjecto === undefined) {
        return "";
      }
      if (this.vectorObjecto.length === 0) {
        if (this.type === "user") {
          return "Cuenta eliminada";
        }
        if (this.type === "sensor") {
          return "Sensor eliminado";
        }
        if (this.type === "building") {
          return "Edificio eliminado";
        }
        if (this.type === "group") {
          return "Grupo eliminado";
        }
        return "Eliminado";
      }
      if (
        this.vectorObjecto[0] === null ||
        this.vectorObjecto[0] === undefined ||
        this.vectorObjecto[0].name === null ||
        this.vectorObjecto[0].name === undefined
      ) {
        return this.idKey;
      } else {
        return this.vectorObjecto[0].name;
      }
    },
    // @vuese
    // Devuelve el color del enlace
    colorEnlace() {
      if (
        this.loading ||
        this.vectorObjecto === null ||
        this.vectorObjecto === undefined
      ) {
        return "";
      }
      if (this.vectorObjecto.length === 0) {
        return "notFound";
      } else {
        return "";
      }
    }
  }
};
</script>

<style scoped>
a {
  color: inherit;
  text-decoration: none;
}

.notFound {
  color: darkred;
  font-weight: bold;
}
</style>
